import { render, staticRenderFns } from "./StackedBars.vue?vue&type=template&id=35bb48b2&scoped=true"
import script from "./StackedBars.vue?vue&type=script&lang=js"
export * from "./StackedBars.vue?vue&type=script&lang=js"
import style0 from "./StackedBars.vue?vue&type=style&index=0&id=35bb48b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bb48b2",
  null
  
)

export default component.exports